<div #avatarContainer class='sf2-avatar_face' [ngStyle]="avatarStyling">
    <h2 *ngIf="this.editable">
        <mat-icon fontSet="salesflare" fontIcon="sf-icon-edit" class="icon-14">
        </mat-icon>
        Edit
    </h2>
</div>
